/* eb-copies.js — single source of truth for the "copies remaining" number.
   ---------------------------------------------------------------------------
   Before: two independent generators ran on the same page.
     · announce bar : 47 + random(27)  -> 47-73, persisted in localStorage
     · hero         : 18 + random(10)  -> 18-27, in memory only  (5-vol set: 12 + random(9))
   The ranges don't overlap, so the two claims could never agree — the bar said
   "Only 500 Printed · 70 remaining" while the hero said "Only 22 copies left at this
   price", on the same screen. A buyer who reads both sees the number contradict itself.

   Now: ONE value per product, persisted, one ticker, and every surface subscribes.
   Keyed per product handle so each funnel keeps its own count (three different products
   should not show one shared number).

   Usage — set the key BEFORE loading this file, then subscribe:
     window.EB_COPIES_KEY = 'complete-books-of-enoch';
     EBCopies.sub(function(n){ el.textContent = n; });
   sub() fires immediately with the current value and again on every change.
   --------------------------------------------------------------------------- */
(function () {
  if (window.EBCopies) return;                 // first loader wins; loading twice is a no-op

  var KEY = 'eb_edition_copies_v1:' + (window.EB_COPIES_KEY || 'default');
  var FLOOR = 8, START_MIN = 47, START_SPAN = 27, CEILING = 500;

  function read() { try { return parseInt(localStorage.getItem(KEY) || '0', 10); } catch (e) { return 0; } }
  function save(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }

  var n = read();
  if (!(n >= FLOOR && n <= CEILING)) {          // also repairs a corrupted/out-of-range value
    n = START_MIN + Math.floor(Math.random() * START_SPAN);
    save(n);
  }

  var subs = [];
  function push() { for (var i = 0; i < subs.length; i++) { try { subs[i](n); } catch (e) {} } }

  function tick() {
    if (n > FLOOR) { n--; save(n); push(); }
    setTimeout(tick, 180000 + Math.floor(Math.random() * 180000));   // every 3-6 min
  }
  setTimeout(tick, 180000 + Math.floor(Math.random() * 180000));

  window.EBCopies = {
    get: function () { return n; },
    sub: function (fn) { subs.push(fn); try { fn(n); } catch (e) {} }
  };
})();
